module.exports = __webpack_public_path__ + "assets/media/level7-user-icon.2a9d0ce2.png";